'use client';

import { motion } from 'framer-motion';
import { memo } from 'react';

export const EngSvg = memo(() => {
  const staggerDelay = 0.04;
  const baseDuration = 0.6;
  const baseDelay = 4; // 스플래시 후 시작

  const easing = [0.25, 0.1, 0.25, 1];

  const letterVariant = (index: number) => ({
    initial: {
      opacity: 0,
      y: 20,
      scale: 0.8,
    },
    animate: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: {
        duration: baseDuration,
        delay: baseDelay + index * staggerDelay,
        ease: easing,
      },
    },
  });

  return (
    <>
      <motion.path
        d="M289.31 280.83H285.041L283.792 275.658L283.055 270.611L282.708 270.589L281.993 275.658L280.749 280.83H276.457L273 266.523H276.577L278.212 273.37L278.643 276.702L279.069 273.37L280.704 266.523H285.058L286.693 273.37L287.147 276.782L287.573 273.37L289.208 266.523H292.767L289.31 280.83Z"
        fill="url(#textGradient)"
        variants={letterVariant(0)}
        initial="initial"
        animate="animate"
      />
      <motion.path
        d="M304.538 269.833H298.162V271.957H303.964V275.272H298.162V277.52H304.538V280.83H294.688V266.523H304.538V269.833Z"
        fill="url(#textGradient)"
        variants={letterVariant(1)}
        initial="initial"
        animate="animate"
      />
      <motion.path
        d="M310.131 277.52H315.938V280.83H306.656V266.523H310.131V277.52Z"
        fill="url(#textGradient)"
        variants={letterVariant(2)}
        initial="initial"
        animate="animate"
      />
      <motion.path
        d="M321.33 277.52H327.132V280.83H317.855V266.523H321.33V277.52Z"
        fill="url(#textGradient)"
        variants={letterVariant(3)}
        initial="initial"
        animate="animate"
      />
      <motion.path
        d="M342.999 273.677C342.999 277.889 339.751 281.096 335.517 281.096C331.283 281.096 328.035 277.889 328.035 273.677C328.035 269.465 331.287 266.257 335.517 266.257C339.747 266.257 342.999 269.465 342.999 273.677ZM331.554 273.677C331.554 276.067 333.229 277.786 335.517 277.786C337.805 277.786 339.485 276.071 339.485 273.677C339.485 271.282 337.81 269.567 335.517 269.567C333.225 269.567 331.554 271.282 331.554 273.677Z"
        fill="url(#textGradient)"
        variants={letterVariant(4)}
        initial="initial"
        animate="animate"
      />

      <motion.path
        d="M277.392 298.403H283.199V301.713H273.918V287.406H277.392V298.403Z"
        fill="url(#textGradient)"
        variants={letterVariant(5)}
        initial="initial"
        animate="animate"
      />
      <motion.path
        d="M299.054 294.558C299.054 298.77 295.802 301.978 291.572 301.978C287.342 301.978 284.09 298.77 284.09 294.558C284.09 290.347 287.338 287.139 291.572 287.139C295.806 287.139 299.054 290.347 299.054 294.558ZM287.609 294.558C287.609 296.949 289.284 298.668 291.576 298.668C293.869 298.668 295.544 296.953 295.544 294.558C295.544 292.164 293.869 290.449 291.576 290.449C289.284 290.449 287.609 292.164 287.609 294.558Z"
        fill="url(#textGradient)"
        variants={letterVariant(6)}
        initial="initial"
        animate="animate"
      />
      <motion.path
        d="M300.77 294.558C300.77 290.347 303.897 287.139 308.189 287.139C311.704 287.139 314.383 289.347 315.16 292.453H311.442C310.868 291.204 309.704 290.449 308.189 290.449C305.817 290.449 304.284 292.164 304.284 294.558C304.284 296.953 305.817 298.668 308.189 298.668C309.7 298.668 310.868 297.913 311.442 296.664H315.16C314.383 299.77 311.704 301.978 308.189 301.978C303.897 301.978 300.77 298.77 300.77 294.558Z"
        fill="url(#textGradient)"
        variants={letterVariant(7)}
        initial="initial"
        animate="animate"
      />
      <motion.path
        d="M320.947 287.406H325.324L330.513 301.713H326.834L325.812 298.749H320.459L319.437 301.713H315.758L320.952 287.406H320.947ZM324.666 295.439L323.133 290.983L321.6 295.439H324.666Z"
        fill="url(#textGradient)"
        variants={letterVariant(8)}
        initial="initial"
        animate="animate"
      />
      <motion.path
        d="M335.904 298.403H341.707V301.713H332.43V287.406H335.904V298.403Z"
        fill="url(#textGradient)"
        variants={letterVariant(9)}
        initial="initial"
        animate="animate"
      />

      <motion.path
        d="M283.768 311.598H277.392V313.868H283.199V317.179H277.392V322.595H273.918V308.288H283.768V311.598Z"
        fill="url(#textGradient)"
        variants={letterVariant(10)}
        initial="initial"
        animate="animate"
      />
      <motion.path
        d="M295.745 311.598H289.365V313.722H295.172V317.036H289.365V319.285H295.745V322.595H285.891V308.288H295.745V311.598Z"
        fill="url(#textGradient)"
        variants={letterVariant(11)}
        initial="initial"
        animate="animate"
      />
      <motion.path
        d="M308.992 318.262C308.992 321.759 305.762 322.861 303.474 322.861C299.098 322.861 297.445 320.306 297.156 317.871H300.671C300.999 319.057 301.63 319.608 303.452 319.608C304.86 319.608 305.496 319.16 305.496 318.404C305.496 317.565 304.638 317.507 302.243 316.991C299.915 316.503 297.521 315.641 297.521 312.677C297.521 309.532 300.32 308.017 303.039 308.017C307.086 308.017 308.619 310.287 308.864 312.757H305.349C305.145 311.918 304.674 311.264 303.039 311.264C301.404 311.264 301.017 311.9 301.017 312.513C301.017 313.188 301.67 313.268 303.083 313.575C307.091 314.432 308.988 315.334 308.988 318.253"
        fill="url(#textGradient)"
        variants={letterVariant(12)}
        initial="initial"
        animate="animate"
      />
      <motion.path
        d="M321.454 311.598H317.549V322.595H314.075V311.598H310.191V308.288H321.454V311.598Z"
        fill="url(#textGradient)"
        variants={letterVariant(13)}
        initial="initial"
        animate="animate"
      />
      <motion.path
        d="M326.01 308.288H330.386L335.576 322.595H331.897L330.875 319.631H325.521L324.499 322.595H320.82L326.014 308.288H326.01ZM329.733 316.321L328.2 311.865L326.667 316.321H329.733Z"
        fill="url(#textGradient)"
        variants={letterVariant(14)}
        initial="initial"
        animate="animate"
      />

      <motion.path
        d="M273.203 341.001L277.393 337.34C280.072 334.99 280.499 334.559 280.499 333.701C280.499 333.008 280.068 332.208 278.761 332.208C277.575 332.208 277.002 332.862 276.86 334.15H273.363C273.487 330.92 275.776 328.898 278.921 328.898C282.067 328.898 284.013 331.067 284.013 333.537C284.013 335.763 282.52 337.011 280.272 338.975L278.944 340.139L278.904 340.161H284.28V343.471H273.203V340.997V341.001Z"
        fill="url(#textGradient)"
        variants={letterVariant(15)}
        initial="initial"
        animate="animate"
      />
      <motion.path
        d="M298.257 336.323C298.257 340.779 295.885 343.743 291.922 343.743C287.959 343.743 285.586 340.779 285.586 336.323C285.586 331.867 287.959 328.903 291.922 328.903C295.885 328.903 298.257 331.867 298.257 336.323ZM294.743 336.323C294.743 333.684 293.948 332.213 291.922 332.213C289.896 332.213 289.1 333.684 289.1 336.323C289.1 338.962 289.896 340.433 291.922 340.433C293.948 340.433 294.743 338.962 294.743 336.323Z"
        fill="url(#textGradient)"
        variants={letterVariant(16)}
        initial="initial"
        animate="animate"
      />
      <motion.path
        d="M299.363 341.001L303.553 337.34C306.232 334.99 306.659 334.559 306.659 333.701C306.659 333.008 306.228 332.208 304.921 332.208C303.735 332.208 303.162 332.862 303.02 334.15H299.523C299.648 330.92 301.936 328.898 305.081 328.898C308.227 328.898 310.173 331.067 310.173 333.537C310.173 335.763 308.68 337.011 306.432 338.975L305.104 340.139L305.064 340.161H310.44V343.471H299.363V340.997V341.001Z"
        fill="url(#textGradient)"
        variants={letterVariant(17)}
        initial="initial"
        animate="animate"
      />
      <motion.path
        d="M323.03 338.55C323.03 341.797 320.618 343.744 317.45 343.744C314.708 343.744 311.972 342.228 311.852 338.754H315.366C315.49 340.003 316.45 340.451 317.41 340.451C318.738 340.451 319.516 339.612 319.516 338.51C319.516 337.346 318.676 336.648 317.472 336.648C316.45 336.648 315.797 337.137 315.553 337.528H312.243L314.02 329.166H322.359V332.476H316.637L316.268 334.275C316.779 333.991 317.432 333.787 318.289 333.787C320.782 333.787 323.03 335.462 323.03 338.55Z"
        fill="url(#textGradient)"
        variants={letterVariant(18)}
        initial="initial"
        animate="animate"
      />

      <defs>
        <linearGradient id="textGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#000000" />
          <stop offset="50%" stopColor="#1a1a1a" />
          <stop offset="100%" stopColor="#000000" />
        </linearGradient>
      </defs>
    </>
  );
});

EngSvg.displayName = 'EngSvg';
